export const GET_FOOTER_TEXT = "(superadminlayout) GET FOOTER TEXT";

export function getFooterText() {
    return {
        type: GET_FOOTER_TEXT,
        text: '© 2019, made with favorite by Creative Tim for a better web.'
    }
}
